<template>

<div>

  <v-layout row class=" primary pl-2 pr-2 " style="">
                          <v-flex  xs12 sm12 offset-sm2  class=" mr-3 ml-3 white hidden-md-and-up">
                              <h3 class="mb-1 text-xs-center" style="color:grey">  Manage Users</h3>
                          </v-flex>
                      </v-layout>

                      <v-layout row class=" primary pl-2 mb-3  hidden-sm-and-down " justify-center style="">
                          <v-flex  xs12 sm12 md6 offset-sm2  class=" mr-3 ml-3 ">
                              <p class="mb-1 mdHeaderText mt-4 mb-4  " > <span style="cursor:pointer"> Admin Panel </span> &nbsp;&nbsp; > &nbsp;&nbsp; Manage Users</p>
                          </v-flex>
                      </v-layout>


    
      <v-layout wrap justify-center  >
        <v-flex xs12 sm8 md8>
                  <v-list two-line class="list">
                <!-- <v-subheader>Users</v-subheader> -->
            
                 <v-text-field append-icon="search" v-model="term" label="Input a user name" hide-details  class="searchBar "></v-text-field>
          <template v-for="item in methodResults">
            <v-list-tile class="listTile" avatar v-bind:key="item.title" >
                            <v-list-tile-avatar v-if=" item.picture">
                              <img v-if="item.picture.url" :src="item.picture.url + '_profile'" >
                              <img v-else :src="item.picture"  >
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-else >
                              <img src="../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.displayName"></v-list-tile-title>
                <v-list-tile-sub-title v-if="item.email"  v-html=" '  <span class=\'grey--text text--lighten-1\'> ' + item.email + '</span>' "> </v-list-tile-sub-title>
                <v-list-tile-sub-title v-else  v-html=" '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + provider(item) + '</span>' ">
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action style="width:130px">
                                <v-select
                                @change="changeStatus(item,$event)"
                                :items="items"
                                v-model="item.role"
                                label="Select"
                                single-line
                                bottom
                            ></v-select>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        </v-flex>
      </v-layout>




</div>

  
</template>

<script>
export default {
  data() {
    return {
      items:['Admin','Moderator','Contributor','User'],
      term: "",
      defaultAllToggle: false,
      options: {
        keys: ["displayName"]
      },
      methodResults: []
    };
  },
  computed: {
    users() {
      return this.$store.getters.loadUsers;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    token() {
      return this.$store.getters.getToken;
    }
  },
  methods: {
    provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";
      else if (user.hasOwnProperty("google")) return "Google";
      else if (user.hasOwnProperty("live")) return "Microsoft Live";
      else return "Local Register";
    },

    changeStatus(user,role) {
      
      this.$store.dispatch("changeUserStatus", {
        id: user._id,
        token: this.token,
        role:role
      }).then((response)=>{
        console.log(response)
        if(response.success)
          this.$store.dispatch("loadUsers");
      });
    }
  },
  mounted() {
     document.title = "Users";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadUsers");
    this.methodResults = this.users;
  },
  watch: {
    term() {
      this.$search(this.term, this.users, this.options).then(results => {
        this.methodResults = results;
        if (this.term == "") {
          this.methodResults = this.users;
        }
      });
    }
  },
    created() {
    if (!this.isAdmin && !this.isLoggedIn) this.$router.push("/signin");
    else if (!this.isAdmin && this.isLoggedIn) this.$router.push("/");
  }
};
</script>

<style scoped>
.application--light .list .subheader {
  color: rgba(0, 0, 0, 0);
}

.list {
  border: 2px solid #efefef;
}

.listTile {
  border-top:1px solid #efefef;
  border-bottom:1px solid #efefef;
  
}

.searchBar { 
  /* padding-top:0px; */

   text-indent:20px; 
  padding-bottom:15px;
  padding-left:20px;
  padding-right:20px;
  
}

.mdHeaderText{
  font-size:1.1em;
  color:white;
}
</style>


<<style>

</style>




// WEBPACK FOOTER //
// src/components/Administration/Users.vue